import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { formOptions, httpOptions, serviceConstants } from 'src/app/constants/service.constants';
import { map, shareReplay } from 'rxjs/operators';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { DocumentreviewComponent } from 'src/app/common/my-reviews/documentreview/documentreview.component';
import { CommonService } from '../common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {


  constructor(private http: HttpClient,
    private commonService: CommonService,
    private modalService: NgbModal) {
    
  }
  
  Insert(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, formOptions);
  }

  Update(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, formOptions);
  }

  DocApplication(url:any, body:any) : Observable<any> {
    return this.http.post(serviceConstants.apiURL+url,body, formOptions);
  }

  GetDocuments(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  

  GetOwner(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  

  GetUsers(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  

  GetReviews(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  

  GetChangeOwnPr(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  

  EditReview(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  
  ReviewDetailsForReferences(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  

  StartReview(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }
  CheckReviwer(url:any): Observable<any>
  {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }
  DeleteReview(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }
  CancelReview(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }
  // CloseReview(url: any): Observable<any> {
  //   return this.http.get(serviceConstants.apiURL+url, httpOptions);
  // }
  // CompleteReview(url: any, body: any): Observable<any> {
  //   return this.http.post(serviceConstants.apiURL+url, body, httpOptions);
  // }
  Changeowner_Review(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, httpOptions);
  }
  UpdateReviewerStatus(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, httpOptions);
  }
  CheckReviwerToAbort(url: any): Observable<any> {
    return this.http.get(serviceConstants.apiURL + url, httpOptions);
  }  

  updateOrder(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, httpOptions);
  }

  GetMyReviews(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, httpOptions);
  }  

  GetReviewsCount(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }  

 UpdateDocReviewerStatus(url: any, body: any) {
  return this.http.post(serviceConstants.apiURL+url,body, httpOptions);
  } 
  
  GetReferenceDocuments(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  } 
  
  GetReviewDocments(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }   
  CheckIsLastTaskComplete(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  } 
  UpdateDocumentStatus(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, httpOptions);
  }  
  UpdateDocument_ReviewStatus(url: any, body: any): Observable<any> {
    return this.http.post(serviceConstants.apiURL+url, body, httpOptions);
  } 

  GetReviewDocuments(url: any) {
    return this.http.get(serviceConstants.apiURL+url, httpOptions);
  }
}
